import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import registry from "../../data/blogMetadata.json";

const normalizePath = (value = "/") => (value.replace(/\/+$/, "") || "/").toLowerCase();

const postsByPath = Object.values(registry.posts).reduce((posts, post) => {
  posts[normalizePath(post.canonicalPath)] = post;
  return posts;
}, {});

/**
 * Owns client-rendered social image tags for every route. The PHP router reads
 * the same registry and writes the matching tags for crawlers before React runs.
 */
const SocialImageMetadata = () => {
  const { pathname } = useLocation();
  const post = postsByPath[normalizePath(pathname)];
  const image = post?.ogImage || registry.fallbackImage.path;
  const imageUrl = `${registry.siteUrl}${image}`;
  const imageAlt = post?.imageAlt || registry.fallbackImage.alt;

  return (
    <Helmet prioritizeSeoTags>
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:url" content={imageUrl} />
      <meta property="og:image:secure_url" content={imageUrl} />
      <meta property="og:image:type" content={registry.fallbackImage.type} />
      <meta property="og:image:width" content={String(registry.fallbackImage.width)} />
      <meta property="og:image:height" content={String(registry.fallbackImage.height)} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={imageAlt} />
    </Helmet>
  );
};

export default SocialImageMetadata;
